<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.menu-mobile
        +e.HEADER.head-nav(ref="menuHeightMobile")
            +e.BUTTON.login-icon(
                v-on:click="toggleLogin"
                v-bind:class="{'is-active' : loginActive}"
                )
                +e.login-img(v-if='getGeneralInfo.isLogin')
                    img(
                        v-if="getGeneralInfo.userInfo.img"
                        v-bind:src="getGeneralInfo.userInfo.img"
                        v-bind:alt="getUserName")
                    +e.V-ICON(name="user" v-else)
                +e.V-ICON.login-svg(v-else name="login")

            +e.close
                +e.BUTTON.close-btn.btn.btn_icon(
                type="button"
                v-on:click="closeMenu"
                )
                    +e.V-ICON.nav-svg(name="close")
        +e.inner
            keep-alive
                menu-mobile-login-box(
                    v-if='loginActive'
                    v-on:close='toggleLogin'
                    )
                sidebar(v-else-if="$route.name === 'Document'")

</template>

<script>
import { mapGetters } from 'vuex';
import MenuMobileLoginBox from '@/components/partials/MenuMobileLoginBox';
import Sidebar from '@/components/partials/Sidebar';

export default {
    components: {
        Sidebar,
        MenuMobileLoginBox
    },
    data() {
        return {
            scrollEl: null,
            loginActive: false,
            langs: ['ru', 'en'],
            currentLang: this.$i18n.locale
        };
    },
    computed: {
        ...mapGetters([
            'getGeneralInfo',
            'getUserName',
            'isSidebarVisible'
        ])
    },
    watch: {
        $route(to) {
            this.currentLang = to.params.lang;
        }
    },
    methods: {
        setLang(lang) {
            this.$i18n.locale = lang;
            this.$router.push({
                params: {
                    lang
                },
                query: {
                    ...this.$route.query
                }
            });
        },
        closeMenu() {
            this.$emit('close', false);
        },
        toggleLogin() {
            this.loginActive = !this.loginActive;
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/partials/menu-mobile.sass"></style>
